import { useState } from "react";
import { InlineAlert, LoadingSpinner } from "../../components/BaseComponents";
import ConfirmationModal from "../../components/BaseComponents/ConfirmationModal";
import useApi from "../../hooks/useApi";
import { getApiErrorMessage, getCSRFToken } from "../../lib/utils";

type DeletePortfolioEntryModalProps = {
    onClose: () => void,
    onDeleted: () => void
    isOpen?: boolean,
    portfolioId: string,
    portfolioName: string,
    companyId: string,
    companyName: string,
};

function DeletePortfolioEntryModal({onClose, onDeleted, isOpen, portfolioId, portfolioName, companyId, companyName}: DeletePortfolioEntryModalProps) {
    const api = useApi();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Issue #884: this POST is behind RequireWriteAccess, so it can now reject with
    // READ_ONLY_ACCESS/ACCESS_AUDIT_UNAVAILABLE (#857 item 6) as well as any generic failure.
    // setLoading(false) previously only ran after the awaited call succeeded, so a rejection left
    // `loading` stuck true forever with no visible error and no false success.
    const deletePortfolio = async () => {
        setLoading(true);
        setError('');
        try {
            await api.post(`/portfolios/${portfolioId}/remove/${companyId}`, {
                _csrf: await getCSRFToken(),
            })
            onDeleted();
        } catch (err: any) {
            setError(getApiErrorMessage(err, 'Failed to remove this organisation from the portfolio. Please try again.'));
        } finally {
            setLoading(false);
        }
    }


    return (
        <ConfirmationModal open={!!isOpen} onCancel={onClose} onConfirm={deletePortfolio} title={`Remove from ${portfolioName}?`}>
            { loading ? (
                <LoadingSpinner />
            ) : (
                <p className="text-white mt-8">
                    Remove {companyName} from this portfolio?
                </p>
            )}
            { error && (
                <InlineAlert type='error' className='mt-4'>{ error }
                </InlineAlert>
            )}
        </ConfirmationModal>
    )
}

export default DeletePortfolioEntryModal;
